import React, { memo } from "react";
import styles from "./styles.module.scss";

interface IProps {
  title: string;
  subtitle?: string;
}

const SectionHeading = ({ title, subtitle }: IProps) => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
};

export default memo(SectionHeading);
